import { ShieldCheck, Truck, Headphones, BadgeCheck } from "lucide-react";
import { FadeUp } from "./Reveal";

const badges = [
  { icon: ShieldCheck, label: "Satisfaction Guarantee" },
  { icon: Truck, label: "Nationwide Shipping" },
  { icon: Headphones, label: "Top-Notch Support" },
  { icon: BadgeCheck, label: "Verified Genetics" },
];

export default function TrustBadges() {
  return (
    <div className="grid grid-cols-2 gap-px overflow-hidden border-y border-yaza-border bg-yaza-border md:grid-cols-4" data-testid="trust-badges">
      {badges.map((b, i) => (
        <FadeUp key={b.label} delay={i * 0.08} className="bg-black">
          <div className="flex flex-col items-center gap-3 px-4 py-10 text-center md:py-14">
            <b.icon className="text-yaza-accent" size={28} strokeWidth={1.5} />
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-white">{b.label}</span>
          </div>
        </FadeUp>
      ))}
    </div>
  );
}
